import { IMenu } from "@core/models/interfaces";

export const LIST_MENU: IMenu[] = [
    {
        "id": 1,
        "code": "careposi_organization_management",
        "name": "事業所管理"
    },
    {
        "id": 2,
        "code": "careposi_map_management",
        "name": "マップ管理"
    }
];
